import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import { I as Icon } from './chunk-7e17a637.js';
export { I as BIcon } from './chunk-7e17a637.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);

export default Plugin;
